import { lazy } from 'react';

// Lazy load all route components for better code splitting
const Dashboard = lazy(() => import("./components/Dashboard/dashboard"));
const OperationsReport = lazy(() => import("./components/Operations/OperationsReport"));
const operationSummary = lazy(() => import("./components/Operations/operationSummary"));
const PlayerSearch = lazy(() => import("./components/Players/playersSearch"));
const Reports = lazy(() => import("./components/Reports/Reports"));
const NewPlayer = lazy(() => import("./components/NewPlayer/newPlayer"));
const PlayerActivity = lazy(() => import("./components/PlayerActivity/playerActivity"));
const KycUsers = lazy(() => import("./components/KycUsers/KycUsers"));
const PlayerReferrals = lazy(() => import("./components/PlayerReferrals/PlayerReferrals"));
const PlayerTagging = lazy(() => import("./components/PlayerTagging/PlayerTagging"));
const AssignTags = lazy(() => import("./components/AssignTags/AssignTags"));
const AssignBounus = lazy(() => import("./components/AssignBonus/AssignBouns"));
const BonusTicker = lazy(() => import("./components/BonusTicker/BonusTicker"));
const PaymentSearch = lazy(() => import("./components/PaymentSearch/paymentSearch"));
const PromotionList = lazy(() => import("./components/PromotionList/PromotionList"));
const CreatePromoMsg = lazy(() => import("./components/CreatePromoMsg/CreatePromoMsg"));
const ArbitrageBet = lazy(() => import("./components/RiskManagement/ArbitrageBet"));
const SyndicateBet = lazy(() => import("./components/RiskManagement/SyndicateBet"));
const SyndicateBettingV2 = lazy(() => import('./components/RiskManagement/SyndicateBettingV2'));
const SyndicateCombinations = lazy(() => import('./components/RiskManagement/SyndicateCombinations'));
const LateBets = lazy(() => import('./components/RiskManagement/LateBets'));
const UsersMacIP = lazy(() => import("./components/RiskManagement/UsersMacIP"));
const UsersIp = lazy(() => import("./components/RiskManagement/UsersIp"));
const CreateBrand = lazy(() => import("./components/CreateBrand/createbrand"));
const CreateClient = lazy(() => import("./components/CreateClient/createclient"));
const BrandKey = lazy(() => import("./components/BrandKey/BrandKey"));
const BrandConfig = lazy(() => import("./components/Brand config/BrandConfig"));
const CurrencyConvert = lazy(() => import("./components/CurrencyConversion/CurrencyConvert"));
const SubAffiliate = lazy(() => import("./components/Affiliate/SubAffiliate"));
const Affiliate = lazy(() => import("./components/Affiliate/Affiliate"));
const PaymentTicker = lazy(() => import("./components/paymentTicker/PaymentTicker"));
const pendingDeposits = lazy(() => import("./components/PendingDeposits/pendingDeposits"));
const pendingWithrawalsSP = lazy(() => import("./components/PendingWithrawals/pendingWithrawalsSP"));
const PendingWithrawals = lazy(() => import("./components/PendingWithrawals/pendingWithrawals"));
const WithdrawalLimit = lazy(() => import("./components/WithdrawalLimits/WithdrawalLimit"));
const PaymentLimits = lazy(() => import("./components/paymentLimits/PaymentLimits"));
const Depositproof = lazy(() => import("./components/DepositProof/Depositproof"));
const BetTicker = lazy(() => import("./components/BetTicker/betTicker"));
const BetHistory = lazy(() => import("./components/BetHistory/betHistory"));
const MultibetConfig = lazy(() => import("./components/Multibet/MultibetConfig"));
const MultibetAccount = lazy(() => import("./components/Multibet/MultibetAccount"));
const CreateUser = lazy(() => import("./components/CreateUser/CreateUser"));
const UserPermission = lazy(() => import("./components/UserPermission/UserPermission"));
const CreatePermission = lazy(() => import("./components/CreatePermission/CreatePermission"));
const BecomeAnAfiliate = lazy(() => import("./components/Affiliate/BecomeAfiliate"));
const createbonusnew = lazy(() => import("./components/createbonusnew/createbonusnew"));
const CreateBonusV2 = lazy(() => import("./components/createbonusv2/CreateBonusV2"));
const BonusListV2 = lazy(() => import("./components/bonuslistv2/BonusListV2"));
const SportsReport = lazy(() => import("./components/Reports/sportsReport/SportsReport"));
const Withdrawal = lazy(() => import("./components/Reports/withdrwalReport/Withdrawal"));
const DepositReport = lazy(() => import("./components/Reports/DepositReport/DepositReport"));
const PlaceBetReport = lazy(() => import("./components/Reports/PlaceBetReport/PlaceBetReport"));
const LiabilityReport = lazy(() => import("./components/Reports/Liability Report/LiabilityReport"));
const AffiliateSummary = lazy(() => import("./components/AffiliateSummary/AffiliateSummary"));
const AccountMsg = lazy(() => import("./components/CreateAccountMsg/AccountMsg"));
const SystemMsg = lazy(() => import("./components/CreateSystemMsg/SystemMsg"));
const BoostedOdds = lazy(() => import("./components/BoostedOdds/BoostedOdds"));
const BoostedOddsConfig = lazy(() => import("./components/BoostedOddsConfig/BoostedOddsConfig"));
const BoostedOddsHistory = lazy(() => import("./components/BoostedOddsConfig/BoostedOddsHistory"));
const WidgetConfig = lazy(() => import("./components/BoostedOddsConfig/WidgetConfig"));
const ActivePlayer = lazy(() => import("./components/ActivePlayer/ActivePlayer"));
const UsersWatchlist = lazy(() => import("./components/UsersWatchlist/UsersWatchlist"));
const newDashboard = lazy(() => import("./components/NewDashboard/newDashboard"));
const BetConfg = lazy(() => import("./components/CyrusUI/BetConfg"));
const BetSettlement = lazy(() => import("./components/CyrusUI/BetSettlement"));
const BetDetails = lazy(() => import("./components/CyrusUI/BetDetails"));
const RegistrationTicker = lazy(() => import("./components/RegistrationTicker/RegistrationTicker"));
const ViewCombi = lazy(() => import("./components/CombiSuggestions/ViewCombi"));
const Combisuggestions = lazy(() => import("./components/CombiSuggestions/Combisuggestions"));
const FailedReports = lazy(() => import("./components/FailedReports/FailedReports"));
const GamesBetHistory = lazy(() => import("./components/GamesBetHistory/GamesBetHistory"));
const CreateWatchList = lazy(() => import("./components/CreateWatchList/CreateWatchList"));
const VipReports = lazy(() => import("./components/VipReports/VipReports"));
const SportsTaxes = lazy(() => import("./components/Taxation/SportsTaxes"));
const GamesTaxation = lazy(() => import("./components/Taxation/GamesTaxation"));
const StakeConfig = lazy(() => import("./components/StakeConfig/StakeConfig"));
const CompetitionIdStatusUpdate = lazy(() => import("./components/CyrusUI/CompetitionIdStatusUpdate"));
const CasinoBetHistory = lazy(() => import("./components/CasinoBetHistory/CasinoBetHistory"));
const DashboardV2 = lazy(() => import("./components/DashboardV2/DashboardV2"));
const BetDecision = lazy(() => import("./components/BetDecision/BetDecision"));
const PromotionsEngine = lazy(() => import("./components/PromotionsEngine/PromotionsEngine"));
const CreateCampaign = lazy(() => import("./components/PromotionsEngine/CreateCampaign"));
const LoyaltyManagement = lazy(() => import("./components/LoyaltyManagement/LoyaltyManagement"));

export const pages = [
  // {
  //     path: "/dashboard",
  //     permissionName: "REPORTING_DASHBOARD",
  //     Component: Dashboard
  // },
  // {
  //   path: "/newdashboard",
  //   permissionName: "REPORTING_NEW_DASHBOARD",
  //   Component: newDashboard
  // },
  {
    path: "/dashboardV2",
    permissionName: "REPORTING_NEW_DASHBOARD",
    Component: DashboardV2
  },
  {
    path: "/report",
    permissionName: "REPORTING_REPORTS",
    Component: Reports
  },
  {
    path: "/report/withdrawalreport",
    permissionName: "REPORTS_WITHDRAWAL",
    Component: Withdrawal
  },
  {
    path: "/report/depositreport",
    permissionName: "REPORTS_DEPOSIT",
    Component: DepositReport
  },
  {
    path: "/report/placebetreport",
    permissionName: "REPORTS_PLACEBET",
    Component: PlaceBetReport
  },
  {
    path: "/report/liabilityreport",
    permissionName: "REPORTS_LIABILITY",
    Component: LiabilityReport
  },
  {
    path: "/operationSummary",
    permissionName: "OPERATION_SUMMARY",
    Component: operationSummary
  },
  {
    path: "/operationReport",
    permissionName: "OPERATION_REPORT",
    Component: OperationsReport
  },
  {
    path: "/vip-reports",
    permissionName: "VIP_BI_REPORTS",
    Component: VipReports
  },
  {
    path: "/falied-reports",
    permissionName: "ADMIN_FAILED_REPORTS",
    Component: FailedReports
  },
  {
    path: "/playersearch",
    permissionName: "PLAYERS_SEARCH",
    Component: PlayerSearch
  },
  {
    path: "/newplayer",
    permissionName: "PLAYERS_NEW",
    Component: NewPlayer
  },
  {
    path: "/playerActivity",
    permissionName: "PLAYER_ACTIVITY",
    Component: PlayerActivity
  },
  {
    path: "/kycusers",
    permissionName: "PLAYERS_KYC_VERIFICATION",
    Component: KycUsers
  },
  {
    path: "/playerreferrals",
    permissionName: "PLAYERS_REFERRALS",
    Component: PlayerReferrals
  },
  {
    path: "/activeplayer",
    permissionName: "ADMIN_ACTIVE_PLAYERS",
    Component: ActivePlayer
  },
  {
    path: "/userswatchlist",
    permissionName: "ADMIN_USERS_WATCHLIST",
    Component: UsersWatchlist
  },
  {
    path: "/registrationTicker",
    permissionName: "REGISTRATION_TICKER",
    Component: RegistrationTicker
  },
  {
    path: "/createTags",
    permissionName: "TAG_CREATE",
    Component: PlayerTagging
  },
  {
    path: "/AssignTags",
    permissionName: "TAG_ASSIGN",
    Component: AssignTags
  },
  {
    path: "/createbonus",
    permissionName: "BONUS_CREATE",
    Component: createbonusnew
  },
  {
    path: "/createbonusv2",
    permissionName: "BONUS_CREATE_V2",
    Component: CreateBonusV2
  },
  {
    path: "/bonuslistv2",
    permissionName: "BONUS_CREATE_V2",
    Component: BonusListV2
  },
  {
    path: "/assignbonus",
    permissionName: "BONUS_APPLY",
    Component: AssignBounus
  },
  {
    path: "/bonusTicker",
    permissionName: "BONUS_TICKER",
    Component: BonusTicker
  },
  {
    path: "/boostedodds",
    permissionName: "BOOSTED_ODDS",
    Component: BoostedOdds
  },
  {
    path: "/boostedoddsconfig",
    permissionName: "BOOSTED_ODDS_CONFIG",
    Component: BoostedOddsConfig
  },
  {
    path: "/widgetconfig",
    permissionName: "BOOSTED_ODDS_CONFIG",
    Component: WidgetConfig
  },
  {
    path: "/boostedoddshistory",
    permissionName: "BOOSTED_ODDS_CONFIG",
    Component: BoostedOddsHistory
  },
  {
    path: "/paymentsearch",
    permissionName: "PAYMENT_SEARCH",
    Component: PaymentSearch,
  },
  {
    path: "/paymentticker",
    permissionName: "PAYMENT_TICKER",
    Component: PaymentTicker
  },
  {
    path: "/pendingdeposits",
    permissionName: "PAYMENT_PENDING_DEPOSIT",
    Component: pendingDeposits
  },
  {
    path: "/pendingwithdrawalsoffline",
    permissionName: "PAYMENT_PENDING_WITHDRAWALS_OFFLINE",
    Component: pendingWithrawalsSP
  },
  {
    path: "/pendingwithdrawals",
    permissionName: "PAYMENT_PENDING_WITHDRAWAL",
    Component: PendingWithrawals
  },
  {
    path: "/withdrawallimit",
    permissionName: "PAYMENT_WITHDRAWAL_LIMIT",
    Component: WithdrawalLimit
  },
  {
    path: "/paymentLimits",
    permissionName: "PAYMENT_LIMITS",
    Component: PaymentLimits
  },
  {
    path: "/depositproof",
    permissionName: "PAYMENTS_DEPOSIT_PROOF",
    Component: Depositproof
  },
  {
    path: "/sports-taxes",
    permissionName: "SPORTS_TAXES",
    Component: SportsTaxes
  },
  {
    path: "/games-taxes",
    permissionName: "GAMES_TAXES",
    Component: GamesTaxation
  },
  {
    path: "/betHistory",
    permissionName: "BETTING_HISTORY",
    Component: BetHistory
  },
  {
    path: "/gamesBetHistory",
    permissionName: "GAMES_BET_HISTORY",
    Component: GamesBetHistory
  },
  {
    path: "/betTicker",
    permissionName: "BETTING_TICKER",
    Component: BetTicker
  },
  {
    path: "/multibetconfiguration",
    permissionName: "BETTING_MULTIBET_CONFIG",
    Component: MultibetConfig
  },
  {
    path: "/multibetaccount",
    permissionName: "BETTING_MULTIBET_ACCOUNTING",
    Component: MultibetAccount
  },
  {
    path: "/combisuggestions",
    permissionName: "ADMIN_COMBI_SUGGESTIONS",
    Component: Combisuggestions
  },
  {
    path: "/viewcombi",
    permissionName: "ADMIN_VIEW_COMBI",
    Component: ViewCombi
  },
  {
    path: "/stakeconfiguration",
    permissionName: "STAKE_CONFIG",
    Component: StakeConfig
  },
  {
    path: "/createuser",
    permissionName: "ADMIN_USER",
    Component: CreateUser
  },
  {
    path: "/createrole",
    permissionName: "ADMIN_ROLE",
    Component: UserPermission
  },
  {
    path: "/createpermission",
    permissionName: "ADMIN_PERMISSION",
    Component: CreatePermission
  },
  {
    path: "/becomeaffiliate",
    permissionName: "ADMIN_BECOME_AFFILIATE",
    Component: BecomeAnAfiliate
  },
  {
    path: "/affiliate",
    permissionName: "ADMIN_AFFILIATE",
    Component: Affiliate

  },
  // {
  //     path: "/subaffiliate",
  //     permissionName: "ADMIN_SUB_AFFILIATE",
  //     Component: SubAffiliate
  // },
  {
    path: "/currncyconversion",
    permissionName: "ADMIN_CURRENCY_CONVERSION",
    Component: CurrencyConvert
  },
  {
    path: "/brandconfig",
    permissionName: "BRAND_CONFIG",
    Component: BrandConfig
  },
  {
    path: "/brandkey",
    permissionName: "BRAND_KEYS",
    Component: BrandKey
  },
  {
    path: "/createclient",
    permissionName: "ADMIN_CREATE_CLIENT",
    Component: CreateClient
  },
  {
    path: "/createbrand",
    permissionName: "ADMIN_CREATE_BRAND",
    Component: CreateBrand
  },
  {
    path: "/usersIp",
    permissionName: "RISK_MANAGMEMENT_USERS_SAME_IP",
    Component: UsersIp
  },
  {
    path: "/usersMac&Ip",
    permissionName: "RISK_MANAGMEMENT_USERS_SAME_ADDRESS",
    Component: UsersMacIP
  },
  {
    path: "/syndicateBet",
    permissionName: "RISK_MANAGMEMENT_SYNDICATE_BETTING",
    Component: SyndicateBet
  },
  {
    path: "/syndicateBettingV2",
    permissionName: "RISK_MANAGMEMENT_SYNDICATE_BETTING_V2",
    Component: SyndicateBettingV2
  },
  {
    path: "/syndicateCombinations",
    permissionName: "RISK_MANAGMEMENT_SYNDICATE_COMBINATIONS",
    Component: SyndicateCombinations
  },
  {
    path: "/lateBets",
    permissionName: "RISK_MANAGMEMENT_LATE_BETS",
    Component: LateBets
  },
  {
    path: "/userswithsamedetails",
    permissionName: "RISK_MANAGMEMENT_ARBITRAGE_BETTING",
    Component: ArbitrageBet
  },
  {
    path: "/createpromomsg",
    permissionName: "ADMIN_COMMUNICATION_CREATEPROMO",
    Component: CreatePromoMsg
  },
  {
    path: "/promotionlist",
    permissionName: "ADMIN_COMMUNICATION_PROMOLIST",
    Component: PromotionList
  },
  {
    path: "/affiliatesummary",
    permissionName: "ADMIN_AFFILIATE_SUMMARY",
    Component: AffiliateSummary
  },
  {
    path: "/createaccountmsg",
    permissionName: "ADMIN_COMMUNICATION_CREATEPROMO",
    Component: AccountMsg
  },
  {
    path: "/createsystemmsg",
    permissionName: "ADMIN_COMMUNICATION_CREATEPROMO",
    Component: SystemMsg
  },
  {
    path: "/betconfig",
    permissionName: "CYRUS_BET_CONFIG",
    Component: BetConfg
  },
  {
    path: "/betsettlement",
    permissionName: "CYRUS_BET_SETTLEMENT",
    Component: BetSettlement
  },
  {
    path: "/betdetails",
    permissionName: "CYRUS_BET_DETAILS",
    Component: BetDetails
  },
  {
    path: "/createwatchlist",
    permissionName: "ADMIN_CREATE_WATCHLIST",
    Component: CreateWatchList
  },
  {
    path: "/competitionidandstatusupdate",
    permissionName: "CYRUS_COMPETITION_ID_STATUS_UPDATE",
    Component: CompetitionIdStatusUpdate
  },
  {
    path: "/casinoBetHistory",
    permissionName: "CASINO_BET_HISTORY",
    Component: CasinoBetHistory,
  },
  {
    path: "/betDecision",
    permissionName: "ADMIN_SPORTS_BET_DECISION",
    Component: BetDecision,
  },
  {
    path: "/promotions-engine",
    permissionName: "PROMOTIONS_ENGINE",
    Component: PromotionsEngine,
  },
  {
    path: "/createcampaign",
    permissionName: "PROMOTIONS_ENGINE",
    Component: CreateCampaign,
  },
  {
    path: "/loyalty-management",
    permissionName: "LOYALTY_MANAGEMENT",
    Component: LoyaltyManagement,
  },

];
